import { DOMOverlay as CarnDOMOverlay } from '@bluebeam/carnivore';

class DOMOverlay {
  id: string;

  index: number;

  domOverlay: CarnDOMOverlay | null;

  constructor(id: string, index: number) {
    this.id = id;
    this.index = index;
    this.domOverlay = null;
  }
}

export default DOMOverlay;
